import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { SetupWizardService } from "@services/setup-wizard.service";
import { combineLatest } from "rxjs";
import { tap } from "rxjs/operators";

enum TableColumns {
  Name = "term_name",
  StartDate = "start_date",
  EndDate = "end_date",
  LastImported = "last_imported",
  IsSelected = "Is Selected",
  Integration = "integration",
  Remove = "remove",
}

@Component({
  selector: "app-wizard-terms",
  templateUrl: "./wizard-terms.component.html",
  styleUrls: ["./wizard-terms.component.scss", "../wizard-styles.scss"],
})
export class WizardTermsComponent implements OnInit {
  public isLoading: boolean = false;
  public searchTerm;
  public columns = TableColumns;
  public rows = [];
  public isProcessing = false;
  public isLoadingTerms: boolean = true;
  public isInitialLoad = true;
  public itemsPerPage: number = 5;
  public itemCount: number = 0;
  public currentPage: number = 1;
  public sortOn: TableColumns = TableColumns.Name;
  public sortAsc: boolean = true;
  public selectedState = "";
  public integrations;
  public terms;
  public tableHeaders = [
    TableColumns.IsSelected,
    TableColumns.Name,
    TableColumns.StartDate,
    TableColumns.EndDate,
    TableColumns.LastImported,
  ];
  public tableHeadersMapToProp = {
    [TableColumns.Name]: "name",
    [TableColumns.StartDate]: "start_at",
    [TableColumns.EndDate]: "end_at",
    [TableColumns.LastImported]: "last_imported",
  };
  public integrationsStillGatheringTerms = [];
  public terms$;
  public integrations$: any;
  public selectedIntegration;
  constructor(
    private wizardService: SetupWizardService,
    private cd: ChangeDetectorRef
  ) {}

  get currentData() {
    const termsToPull = this?.selectedIntegration?.value?.termsToPull
    return !termsToPull?.length? []: termsToPull.map(({ id }) =>
      String(id)
    )
  }

  ngOnInit() {
    this.integrations$ = this.wizardService.integrations$.pipe(
      tap(({ selectedIntegration }) => {
        this.selectedIntegration = selectedIntegration;
      })
    );
    this.terms = combineLatest([
      this.wizardService.getTerms$(),
      this.wizardService.getIntegrations$(),
    ]).subscribe(([terms, integrations]) => {
      this.isInitialLoad = integrations.isLoading || terms.isLoading;
      if (this.isInitialLoad) return;
      this.terms = terms.list;
      this.isProcessing = terms.isProcessing;
      this.rows = this.mapTermsToRows(terms.list);
      this.itemCount = terms.itemCount;
      this.cd.detectChanges();
    });
  }

  getCountLabel() {
    const start = this.currentPage * this.itemsPerPage - this.itemsPerPage + 1;
    const end = Math.min(this.currentPage * this.itemsPerPage, this.itemCount);
    return `${start} - ${end} of ${this.itemCount} Items`;
  }

  updateSelectedState($event) {
    this.currentPage = 1;
    this.selectedState = $event;
    this.wizardService.getTermsNetworkRequest$({
      pageNumber: this.currentPage - 1,
      status: this.selectedState,
    });
  }

  initSearch() {
    this.currentPage = 1;
    this.wizardService.getTermsNetworkRequest$({
      pageNumber: this.currentPage - 1,
      searchTerm: this.searchTerm,
    });
  }
  mapTermsToRows(terms) {
    if (!Array.isArray(terms)) return [];
    return terms.map((term) => {
      const isSelected = this.currentData.includes(term.id);
      return {
        id: term.id,
        [TableColumns.IsSelected]: isSelected,
        [TableColumns.Name]: term?.data?.name || "",
        [TableColumns.StartDate]: term?.data?.start_at || "",
        [TableColumns.EndDate]: term?.data?.end_at || "",
        [TableColumns.LastImported]: term?.data?.last_imported,
        term: term,
      };
    });
  }

  updateSelected(row) {
    row[TableColumns.IsSelected] = !row[TableColumns.IsSelected];
    if (row[TableColumns.IsSelected]) {
      this?.selectedIntegration?.value?.termsToPull.push(row);
    } else {
      const index = this.currentData.indexOf(row.id);
      this?.selectedIntegration?.value?.termsToPull.splice(index, 1);
    }
  }

  sortOnHeader(header) {
    this.sortAsc = header === this.sortOn ? !this.sortAsc : true;
    this.sortOn = header;
    this.currentPage = 1;
    const orderBy = this.tableHeadersMapToProp[header];
    this.wizardService.getTermsNetworkRequest$({
      pageNumber: this.currentPage - 1,
      orderBy,
      direction: this.sortAsc ? "ASC" : "DESC",
    });
  }

  activePageChange(pageNumber) {
    this.currentPage = pageNumber;
    this.wizardService.getTermsNetworkRequest$({
      pageNumber: this.currentPage - 1,
    });
  }
}
